module.exports = __webpack_public_path__ + "static/mh-task3-fca641580e9f633676f89140b9a41cd3.jpeg";